import cn from "classnames";
import "./index.css";
import BgTransformer from "../../../layout/BgTransformer";
import PixelationLayer from "../../../layout/PixelationLayer";
import {useSetting} from "../../../contexts/setting";
import {useBgUrl} from "hooks/useBgUrl";
import {DemoVideoScreenshot} from "./parts";

/**
 * Demo (Figma "release/demo/background" 12710:1424): the screenshot on the
 * product artwork, with a margin of the artwork on every side.
 */
const DemoVideoDemo = ({id, zoom}: {id: string; zoom: number}) => {
  const {product} = useSetting();
  const {url: bgUrl} = useBgUrl();

  return (
    <div
      id={id}
      className={cn("template", product.value, "demo-video", "demo-video-demo")}
      style={{"--zoom-level": zoom} as React.CSSProperties}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        <PixelationLayer />
        <DemoVideoScreenshot id={id} />
      </div>
    </div>
  );
};

export default DemoVideoDemo;
